import {
  AmeritradeSymbolQuotesResponse,
  QuoteDataResponse,
} from "./../Models/AmeritradeSymbolQuotesResponse";
import { DOCUMENT } from "@angular/common";
import { HttpClient } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { Router } from "@angular/router";
import * as signalR from "@aspnet/signalr";
import { BehaviorSubject } from "rxjs";
import { Config } from "../Models/Config";
import { AuthorizationService } from "./authorization.service";

declare const settings: any;

@Injectable({
  providedIn: "root",
})
export class MainHubService {
  configUrl = "/API/GetSettings";
  config: Config;

  mainHubConnection: signalR.HubConnection;
  loginHubConnection: signalR.HubConnection;

  mainHubConnected: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(
    false
  );
  needAmeritradeLogin: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(
    false
  );

  constructor(
    private http: HttpClient,
    private authorizationService: AuthorizationService,
    private router: Router,
    @Inject(DOCUMENT) private document: Document
  ) {
    if (this.authorizationService.authenticated.value) {
      this.connect();
    }
  }

  async connectLogin(): Promise<boolean> {
    if (
      !this.loginHubConnection ||
      this.loginHubConnection.state != signalR.HubConnectionState.Connected
    ) {
    //  let cfg = await this.getClientConfig();
    var signalRUrl = "https://binter.tradinghosting.com/signalr/";
      this.loginHubConnection = new signalR.HubConnectionBuilder()
        .withUrl(`${signalRUrl}/login`, {})
        .build();
      await this.loginHubConnection.start();
      return (
        this.loginHubConnection.state == signalR.HubConnectionState.Connected
      );
    } else {
      return true;
    }
  }
  async connect(): Promise<boolean> {
   // let cfg = await this.getClientConfig();
    if (!this.mainHubConnection) {
      var signalRUrl = "https://binter.tradinghosting.com/signalr/";
      this.mainHubConnection = new signalR.HubConnectionBuilder()
        .withUrl(`${signalRUrl}/main`, {
          accessTokenFactory: () => this.authorizationService.getToken(),
          logMessageContent: true,
          logger: signalR.LogLevel.Debug,
        })
        .build();
      this.authorizationService.authenticated.subscribe((isLoggedIn) => {
        if (isLoggedIn) {
          if (
            this.mainHubConnection.state ==
            signalR.HubConnectionState.Disconnected
          ) {
            this.mainHubConnection.start().then(() => {
              this.mainHubConnected.next(true);
            });
          }
        } else {
          if (this.mainHubConnection) {
            this.mainHubConnection.stop().then(() => {
              this.mainHubConnected.next(false);
            });
          }
        }
      });
      this.mainHubConnection.keepAliveIntervalInMilliseconds = 15 * 1000; // 15s
      this.mainHubConnection.serverTimeoutInMilliseconds = 32 * 1000; //32 s
    }

    this.bindings();

    return this.mainHubConnected.value;
  }

  async getClientConfig(): Promise<Config> {
    return new Promise((rs, rj) => {
      if (this.config) {
        rs(this.config);
      } else {
        this.http
          .get(this.configUrl)
          .toPromise()
          .then((r: Config) => {
            this.config = r;
            rs(r);
          });
      }
    });
  }

  bindings() {
    this.mainHubConnection.on("NeedAmeritradeTokenData", () => {
      this.needAmeritradeLogin.next(true);
    });
  }

  public async loginToAmeritrade() {
    let url = await this.getAmeritradeReturnUrl();
    document.location.href = url;
  }
  public getAmeritradeReturnUrl(): Promise<string> {
    if (this.mainHubConnection.state != signalR.HubConnectionState.Connected) {
      return;
    }
    return this.mainHubConnection.invoke<string>("GetAmeritradeAuthUrl");
  }

  public async login(login: string, password: string): Promise<boolean> {
    if (await this.connectLogin()) {
      const response = await this.loginHubConnection.invoke<{
        token: string;
        error: string;
      }>("Login", { Login: login, Password: password });
      if (response.error) {
        return false;
      } else {
        this.authorizationService.setToken(response.token);
        return true;
      }
    }
  }

  public async checkProvider() {
    if (await this.connect()) {
    }
  }

  public async createAmeritradeToken(code: string): Promise<boolean> {
    var response = await this.mainHubConnection.invoke<{
      isCreated: boolean;
      error: string;
    }>("CreateAmeritradeToken", { Code: code });
    if (response.error) {
      this.needAmeritradeLogin.next(true);
      return false;
    }
    this.needAmeritradeLogin.next(false);
    return response.isCreated;
  }

  public async addSymbol(symbolName: string): Promise<boolean> {
    const response = await this.mainHubConnection.invoke<{ error: string }>(
      "AddSymbol",
      { Name: symbolName }
    );
    if (response.error) {
      alert(response.error);
    } else {
      return true;
    }
  }

  public async setFilter(filterName: string, value: string): Promise<boolean> {
    const response = await this.mainHubConnection.invoke<{ error: string }>(
      "SetFilter",
      { Name: filterName, Value: value }
    );
    if (response.error) {
      alert(response.error);
    } else {
      return true;
    }
  }

  public async getFilter(filterName: string): Promise<string> {
    let response = await this.mainHubConnection.invoke<{
      error: string;
      value: string;
    }>("GetFilter", { Name: filterName });
    if (response.error) {
      alert(response.error);
    } else {
      return response.value;
    }
  }

  public async removeSymbol(symbolName: string): Promise<boolean> {
    const response = await this.mainHubConnection.invoke<{ error: string }>(
      "RemoveSymbol",
      { Name: symbolName }
    );
    if (response.error) {
      alert(response.error);
    } else {
      return true;
    }
  }
}
